import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface AppFlowState {
  notificationPromptEligible: boolean;
}

const initialState: AppFlowState = {
  notificationPromptEligible: false,
};

export const appFlowSlice = createSlice({
  name: 'appFlow',
  initialState,
  reducers: {
    setNotificationPromptEligible: (state, action: PayloadAction<boolean>) => {
      state.notificationPromptEligible = action.payload;
    },
  },
});

export default appFlowSlice.reducer;
export const appFlowActions = appFlowSlice.actions;
